import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../types/auth/EmployeeUpdateDTO";

// Настойки для API Review
export const apiQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL+"/api/v1",
  prepareHeaders: (headers, { getState }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const {
      auth: { token },
    } = getState() as RootState;
    headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});


// Настойки для API Review
export const apiV2Query = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_BASE_URL+"/api/v2",
  prepareHeaders: (headers, { getState }) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const {
      auth: { token },
    } = getState() as RootState;
    headers.set("Authorization", `Bearer ${token}`);
    return headers;
  },
});

export interface Param {
  name: string;
  value: any;
}

export const getUrl = (url: string, params: Param[] | null) =>{
  return params?.at(0)?.value !== null && params?.at(0)?.value !== undefined
      ? joinToString(params, "&", url + "?", "", (item) =>
          item.value!==null && item.value!==undefined ? `${item.name}=${item.value}` : ""
      )
      : url;
}

export function joinToString<T>(
  array: T[],
  separator: string = ",",
  prefix: string = "",
  suffix: string = "",
  transform: (item: T) => string
) {
  let res = prefix;
  for (let i = 0; i < array.length; i++) {
    if (i !== 0 && transform(array[i]) !== "") {
      res += separator;
    }
    res += transform(array[i]);
  }
  res += suffix;
  return res;
}
